class OpalWoocommerceSingleProduct {
    constructor() {
        this.initSlideProduct();
    }

    initSlideProduct() {

        let lightbox = $('.single-product .woocommerce-product-gallery__image > a');

        if (lightbox.length) {
            lightbox.attr("data-elementor-open-lightbox", "no");
        }

        $('.woocommerce-product-gallery').on('wc-product-gallery-after-init', function () {

            let rtl = $('body').hasClass('rtl') ? true : false;
            let thumb_signle = $('.flex-control-thumbs img', '.woocommerce-product-gallery');
            if ($('.woocommerce-product-gallery__wrapper').children().length > 5) {
                $('.woocommerce-single-style-4 .woocommerce-product-gallery .flex-control-thumbs').slick({
                    rtl: rtl,
                    infinite: false,
                    slidesToShow: 4,
                    vertical: true,
                    verticalSwiping: true,
                });
            }
            $('.woocommerce-product-gallery .flex-control-thumbs li').each(function () {
                $(this).has('.flex-active').addClass('active');
            });
            thumb_signle.click(function () {
                thumb_signle.parent().removeClass('active');
                $(this).parent().addClass('active');
            });
        });
    }


}

new OpalWoocommerceSingleProduct();